import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { PromotionsBlock } from 'widgets/avia'
import { BeketSearchForm } from 'widgets/beket/beket-search-form'
import { HeaderTabs } from 'widgets/header-tabs'
import { Count } from 'widgets/level-count/level-count'

import findTicketFormStore from 'entities/beket/models/find-ticket/find-ticket-store'
import formPassengersState from 'entities/beket/models/form-passengers/form-passengers-state'
import beketListTicketsStore from 'entities/beket/models/ticket/beket-list-tickets/beket-list-tickets-store'
import formPassengersStore from 'entities/ticket/models/form-passengers/form-passengers-store'
import listTicketsStore from 'entities/ticket/models/list-tickets/list-tickets-store'
import userStore from 'entities/user/module/user-store'

import { BottomNavigation } from 'shared/ui/bottom-navigation'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { Paper } from 'shared/ui/paper'
import { PopupContent } from 'shared/ui/poup-content'

import s from './styles.module.scss'

const BeketPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { openDialog, closeDialog } = useDialogBottomSheet()

  useEffect(() => {
    formPassengersStore.clearValuesForm()
    listTicketsStore.resetListOfTicket()
  }, [])

  const onSwitchDirections = () => {
    findTicketFormStore.onSwitchDirection(0)
  }

  const onChange = (data?: Count) => {
    findTicketFormStore.onSetCount(data)
  }

  const onShowPopUpUnavaliable = () => {
    openDialog({
      isDialog: false,
      child: (
        <PopupContent
          button={t('close')}
          title="Техническое обновление"
          description="Поставщик временно недоступен. Пожалуйста, повторите попытку позже"
          onClick={closeDialog}
        />
      ),
    })
  }

  const onSearch = () => {
    if (userStore.userSettings?.bus_service_available) {
      formPassengersState.clearValuesForm()
      beketListTicketsStore.resetListOfTicket()
      navigate(RoutingPaths.beket.searchResults.base())
    } else {
      onShowPopUpUnavaliable()
    }
  }

  return (
    <div className={clsx('bgGrey', s.container)}>
      <HeaderTabs module="buses" />

      <Paper
        padding={[16]}
        radius={'28px'}
        className={s.paper}
      >
        <div className={s.wrapper}>
          <p className={s.title}>{t('beket.page.title')}</p>

          <p className={s.subTitle}>{t('beket.page.sub_title')}</p>
        </div>

        <BeketSearchForm
          isAvailable={userStore.userSettings?.bus_service_available}
          type={'lightGrey'}
          searchData={findTicketFormStore.formFindTicket}
          onChange={onChange}
          onSearch={onSearch}
          onSwitch={onSwitchDirections}
          onShowError={onShowPopUpUnavaliable}
        />
      </Paper>

      <div className={s.promotions}>
        <PromotionsBlock type="buses" />
      </div>

      {/* <FastActions
        orderUrl={RoutingPaths.beket.orders.path()}
        supportUrl={RoutingPaths.feedback.path()}
      /> */}

      <BottomNavigation activeId="home" />
    </div>
  )
})

export default BeketPage
